<app-filter-controls class="view-board__header"></app-filter-controls>
<app-board class="view-board__board" [ngClass]="{ 'view-board__board_hidden': isOpenTask() }"></app-board>
@if (isOpenTask()) {
  <app-task-view class="view-board__task"></app-task-view>
}
